import { DriverDownnloadInvoiceFilterInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

const downloadManyInvoices = (input: DriverDownnloadInvoiceFilterInput) =>
  driverApi.post<DriverDownnloadInvoiceFilterInput, void>('/v2/invoice/schedule-many', input);

export const useDownloadManyInvoices = () =>
  useMutation<void, unknown, DriverDownnloadInvoiceFilterInput>({
    mutationFn: downloadManyInvoices,
  });
